// components/DocumentListViewer.tsx

import { Box, Dialog, DialogContent, DialogTitle, IconButton, List, ListItem, ListItemText, makeStyles } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
// import { MovieOutlined as MovieIcon } from "@material-ui/icons";
// import { DescriptionOutlined as DescriptionIcon } from "@material-ui/icons";
import { PrivateBlob } from "Custom/Components/Image/PrivateImage";
import React, { useState } from "react";

import { ReactComponent as Media } from "Custom/Content/media.svg";
import { ReactComponent as Document } from "Custom/Content/document.svg";

export interface DocumentItem {
    imageUrl: string;
    fileName?: string;
}

interface DocumentListViewerProps {
    documents: DocumentItem[];
    title?: string;
    className?: string;
}

const useStyles = makeStyles({
    listItem: {
        borderRadius: "5px",
        transition: "all 0.2s ease",
        height: "31px",
        marginBottom: "6px",
        "&:hover": {
            border: "1px solid #449B23",
            opacity: 1,
        },
        "&:focus": {
            border: "1px solid #449B23",
            opacity: 1,
        },
        "& > div:first-child": {
            width: "30px",
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        },
    },
    listItemText: {
        padding: "0",
        margin: "0",
        "& .MuiListItemText-primary": {
            textAlign: "left",
            font: "normal normal normal 14px/17px Inter",
            letterSpacing: "-0.35px",
            color: "#191919",
            opacity: 1,
        },
    },
});

const DocumentListViewer: React.FC<DocumentListViewerProps> = ({ documents, title = "Preview", className }) => {
    const classes = useStyles();
    const [openPreview, setOpenPreview] = useState(false);
    const [currentDoc, setCurrentDoc] = useState<DocumentItem | null>(null);

    const handleOpen = (doc: DocumentItem) => {
        setCurrentDoc(doc);
        setOpenPreview(true);
    };

    const handleClose = () => {
        setOpenPreview(false);
        setCurrentDoc(null);
    };

    const getFileExtension = (url: string) =>
        url
            ?.split(".")
            .pop()
            ?.toLowerCase();

    return (
        <>
            <Box className={className}>
                <List>
                    {documents.map((doc, index) => {
                        const ext = getFileExtension(doc.imageUrl);
                        const isVideo = ext === "mp4";

                        return (
                            <ListItem button key={index} onClick={() => handleOpen(doc)} className={classes.listItem}>
                                <div>{isVideo ? <Media style={{ marginRight: 10 }} /> : <Document style={{ marginRight: 10 }} />}</div>
                                <ListItemText primary={doc.fileName || `Document ${index + 1}`} className={classes.listItemText} />
                            </ListItem>
                        );
                    })}
                </List>
            </Box>

            <Dialog open={openPreview} onClose={handleClose} maxWidth="lg" fullWidth>
                <DialogTitle>
                    {title}
                    <IconButton onClick={handleClose} style={{ position: "absolute", right: 8, top: 8 }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    {currentDoc && currentDoc.imageUrl && (
                        <>
                            {getFileExtension(currentDoc.imageUrl) === "mp4" ? (
                                <PrivateBlob src={currentDoc.imageUrl} asMedia={true} />
                            ) : (
                                <PrivateBlob src={currentDoc.imageUrl} asiFrame={true} />
                            )}
                        </>
                    )}
                </DialogContent>
            </Dialog>
        </>
    );
};

export default DocumentListViewer;
